import React from 'react';
import { Card, CardContent } from './ui/card';
import { solutions } from '../data/mockData';
import { CreditCard, User, Award, Key, Check } from 'lucide-react';

const iconMap = {
  CreditCard,
  User,
  Award,
  Key,
};

const Solutions = () => {
  return (
    <section id="solutions" className="py-24 bg-[#101F27] relative overflow-hidden">
      {/* Background Elements */}
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-[#009688] to-transparent opacity-50"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <p className="text-base md:text-lg font-semibold text-[#009688] uppercase tracking-wide mb-4">
            Core Solutions
          </p>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            What <span className="text-white">WristCoin</span> Does
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            Modular capabilities that work across all industries, from spas to resorts to events
          </p>
        </div>

        {/* Solutions Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-6xl mx-auto">
          {solutions.map((solution, index) => {
            const Icon = iconMap[solution.icon];
            return (
              <Card
                key={index}
                className="bg-[#37464F]/50 border-gray-800 hover:border-[#009688]/50 transition-all duration-300 hover:shadow-xl hover:shadow-[#009688]/10 group"
              >
                <CardContent className="p-8">
                  {/* Icon & Title */}
                  <div className="flex items-start space-x-4 mb-6">
                    <div className="flex-shrink-0 p-4 bg-gradient-to-br from-[#009688]/10 to-[#005B4F]/10 rounded-xl group-hover:scale-110 transition-transform duration-300">
                      <Icon className="w-8 h-8 text-[#009688]" />
                    </div>
                    <div className="flex-1">
                      <h3 className="text-2xl font-bold text-white mb-1">{solution.title}</h3>
                      <p className="text-sm text-[#009688]">{solution.subtitle}</p>
                    </div>
                  </div>

                  {/* Description */}
                  <p className="text-gray-400 leading-relaxed mb-6">{solution.description}</p>

                  {/* Features List */}
                  <ul className="space-y-2">
                    {solution.features.map((feature, idx) => (
                      <li key={idx} className="flex items-start">
                        <Check className="w-4 h-4 text-[#009688] mr-2 mt-0.5 flex-shrink-0" />
                        <span className="text-gray-300 text-sm">{feature}</span>
                      </li>
                    ))}
                  </ul>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Bottom Info */}
        <div className="text-center mt-16">
          <p className="text-gray-400 mb-6">
            Each solution integrates seamlessly with your existing systems
          </p>
          <button
            onClick={() => {
              const element = document.getElementById('integrations');
              if (element) element.scrollIntoView({ behavior: 'smooth' });
            }}
            className="text-[#009688] font-semibold hover:underline"
          >
            View our integrations →
          </button>
        </div>
      </div>
    </section>
  );
};

export default Solutions;
